import {defaultAxios, constants} from '../data/httpWithAxios';

export default {
    addDepartment: function(department) {
        return defaultAxios(constants.contentType.application_json)
                .post('/rc/cs/web/corp/addDepartment', department).then(response => {
                    return response;
                })
    },
    modifyDepartment: function(department) {
        return defaultAxios(constants.contentType.application_json)
                .post('/rc/cs/web/corp/updateDepartment', department).then(response => {
                    return response;
                })
    },
    departmentList: function(corpNo) {
        return defaultAxios(constants.contentType.application_json)
                .get('/rc/cs/web/corp/departments', {
                    params: {
                        corpNo: corpNo
                    }
                }).then(response => {
                    return response;
                })
    },
    departmentInfo: function(corpNo, deptNo) {
        return defaultAxios(constants.contentType.application_json)
                .get('/rc/cs/web/corp/department', {
                    params: {
                        corpNo: corpNo,
                        deptNo: deptNo
                    }
                }).then(response => {
                    return response;
                })
    }
}


// WEBPACK FOOTER //
// ./src/api/department.js